function RequestedStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#F5F5F5] font-OpenSansSemiBold font-[600] text-[#404040] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Requested
    </div>
  );
}

export default RequestedStatus;
